<template>
  <div class="collectProductContent" v-if="isLogined">
    <div class="title">
      商品收藏 
      
      <div class="cancelManageCollect" v-if="isManage"><input type="button" value="取消管理" @click="manageCollect(false)"></div>
      <div class="manageCollect" v-else><input type="button" value="收藏管理" @click="manageCollect(true)"></div>
      <div class="delCollect" v-if="isManage" @click="delCollect"> <img src="https://file-sz.fjjykj.com.cn/Supply/s4fa98fed29b1ec7c9825589935fabd4a.png"> <div class="labelName">删除</div></div>
      <div class="allSelect" v-if="isManage"> <el-checkbox v-model="isAll" @change="handleCheckboxChange"/><span class="labelName"  @click="allSelect">全选</span></div>
      
    </div>
    <div class="collectProductList" :key="collectProductIndex"> 
      <ul v-if="productList.length>0">
          <li v-for="(item,i) in productList" :key="'goods_'+i">                          
            <div class="recommendProductImage">
              <img class="recommendImg" :src="item.defaultImage" @click="toGoodsDetail(item.id)" />
              <img class="productIcon"  v-for="(labelItem,labelIndex) in item.labels" v-if="labelIndex<1&&labelItem.labelIcon&&!isManage" :key="labelIndex" :src="labelItem.labelIcon" />
              <div class="selectProduct" v-if="isManage">
                <el-checkbox v-model="item.checked" />
              </div>
              <div class="delProduct"><img @click="delCollectItem(item.id)" src="https://file-sz.fjjykj.com.cn/Supply/s7700d715392bcc97de0073f0ed076c23.png"></div>
            </div>
            <div class="productname" style="height:20px;" @click="toGoodsDetail(item.id)">
              {{item.name}}
            </div>
            <div class="productprice">
              <span class="price">
                ￥{{item.settlementPrice}}
                  <span class="scribe" v-if="item.settlementPrice<item.sellPrice">
                    ￥{{item.sellPrice}}
                  </span>
              </span>
              <span class="sales">
                  成交{{item.sales}}件
              </span>
            </div>                                
            <div class="operationBtn">
                <a @click="toGoodsDetail(item.id)"><y-button text="查看详情"></y-button></a>                      
                <y-button text="加入购物车" @btnClick="showModal(item)" classStyle="main-btn"></y-button>
            </div>                         
          </li>      
      </ul>  
     </div>   
     <div class="collectPaging" v-if="productList.length>0">
      <el-pagination                    
                      @current-change="handleCurrentChange"
                      :page-size="queryForm.MaxResultCount"
                      @size-change="handleSizeChange"
                      :current-page.sync="queryForm.SkipCount"
                      layout="prev, pager, next, jumper"
                      :total="goodsTotal">
       </el-pagination>   
     </div>
    <selectSpec ref="selectSpec"></selectSpec>
  </div>
</template>
<style>
@import '../../styles/collectProduct.css';
</style>
<script>
  import api from '@/api'
  import { getCollectProducts, batchRemoveCollect } from '@/api/productDetail'
  import YButton from '@/components/yButton'
  import SelectSpec from './components/SelectSpec' 
  import YShelf from '@/components/shelf' 
  import { mapState} from 'vuex'
  export default {
    
    data () {
      return {
        isAll:false,
        isManage:false,
        productList: [],   
        goodsTotal:0,
        collectProductIndex:0,
        queryForm:{
          SkipCount:1,
          MaxResultCount:8
        }
      }
    },
    computed: {
      ...mapState(['isLogined']), 
    },
    methods: { 
      toLogin() {
        this.$router.push({ name: 'userLogin' })
      },
      message (m) {
        this.$message.error({
          message: m
        })
      },
      manageCollect(val)
      {
        this.isManage=val;
      },
      delCollect()
      {
        var tempIds = [];
        for(var i=0;i<this.productList.length;i++)
        {
            if(this.productList[i].checked==true)
            {
               tempIds.push(this.productList[i].id);
            }
        }
        if(tempIds.length==0)
        {
          this.$message({ message: '请选择要删除的收藏', type: 'error', customClass: 'c-msg' })
          return;
        }
        this.$confirm('确定删除吗?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'}).then((res) => {
          batchRemoveCollect({productIds:tempIds}).then(res => {
            this.$message({ message: '删除成功', type: 'success', customClass: 'c-msg' })
           this._collectList()
          })
        })        
      },
      delCollectItem(id)
      {
        var tempIds = [];
        tempIds.push(id);
        this.$confirm('确定删除吗?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'}).then((res) => {
          batchRemoveCollect({productIds:tempIds}).then(res => {
            this.$message({ message: '删除成功', type: 'success', customClass: 'c-msg' })
           this._collectList()
          })
        })        
      },
      allSelect()
      {       
        this.collectProductIndex = this.collectProductIndex+1;
         if(this.isAll)
         {
            this.isAll=false;
            for(var i=0;i<this.productList.length;i++)
            {
              this.productList[i].checked=false;
            }
         }
         else
         {
            this.isAll=true;
            for(var i=0;i<this.productList.length;i++)
            {
              this.productList[i].checked=true;
            }
         }
      },
      handleCheckboxChange()
      {
        this.isAll= !this.isAll;
        this.allSelect();
      },
      toGoodsDetail(id)
      {        
        window.open('//' + window.location.host + '/#/goodsDetails?productId=' + id)
      },
      showModal(item){     
        this.$refs['selectSpec'].showSelect(item)         
      },
      handleSizeChange (val) {
        this.queryForm.MaxResultCount = val
        this._collectList()
      },
      handleCurrentChange (val) {
        this.queryForm.SkipCount = val
        this._collectList()
      },
      async _collectList () { 
        await getCollectProducts(this.queryForm).then(res => {     
          if (res.data.success === true) {
            this.productList = [];
            res.data.result.items.forEach(x => {
              var temp = {checked:false };
              let newObj = { ...x, ...temp };
              this.productList.push(newObj)
            });
            this.goodsTotal = res.data.result.totalCount;
          } else {
           this.productList = []
          }
        }).catch(error => {
            this.productList = []
        })
      },           
    },
    created () {
     if(this.isLogined) 
     {      
        this._collectList()
     }
    },
    mounted() {
     
    },
    components: {
      YButton,
      YShelf,
      SelectSpec
    }
  }
</script>


// WEBPACK FOOTER //
// CollectProductList.vue?3b54817a